import React from "react";
import { useTranslation } from "react-i18next";
import checkIcon from "../../img/experience/execution-check.svg";

const FEATURES = [
  { titleKey: "trade.security.f1.title", descKey: "trade.security.f1.desc" },
  { titleKey: "trade.security.f2.title", descKey: "trade.security.f2.desc" },
  { titleKey: "trade.security.f3.title", descKey: "trade.security.f3.desc" },
  { titleKey: "trade.security.f4.title", descKey: "trade.security.f4.desc" },
];

function FeatureItem({ titleKey, descKey }) {
  const { t } = useTranslation();
  return (
    <div className="flex gap-[20px] xl:gap-[40px] items-start">
      <div className="bg-[#ededed] flex items-center justify-center rounded-[15px] xl:rounded-[28px] shrink-0 w-[30px] h-[30px] xl:w-[56px] xl:h-[56px] p-[7px] xl:p-[13px]">
        <div className="w-full h-full relative flex items-center justify-center">
         <svg xmlns="http://www.w3.org/2000/svg" width="25" height="19" viewBox="0 0 25 19" fill="none">
          <path d="M9.37437 18.6431C9.14062 18.8781 8.82187 19.0094 8.49063 19.0094C8.15938 19.0094 7.84063 18.8781 7.60688 18.6431L0.549375 11.5844C-0.183125 10.8519 -0.183125 9.66437 0.549375 8.93312L1.43313 8.04937C2.16563 7.31687 3.35187 7.31687 4.08437 8.04937L8.49063 12.4556L20.3969 0.549375C21.1294 -0.183125 22.3169 -0.183125 23.0481 0.549375L23.9319 1.43313C24.6644 2.16563 24.6644 3.35313 23.9319 4.08438L9.37437 18.6431Z" fill="#ACACAC"/>
        </svg>
        </div>
      </div>
      <div className="flex flex-col gap-[12px] flex-1">
        <h3 className="font-['Montserrat'] font-semibold text-[16px] xl:text-[20px] text-[#0a0a0a] leading-normal">
          {t(titleKey)}
        </h3>
        <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#aaa] leading-[1.4]">
          {t(descKey)}
        </p>
      </div>
    </div>
  );
}

function Security() {
  const { t } = useTranslation();

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col gap-[40px] xl:gap-[60px]">

        {/* Header */}
        <div className="flex flex-col xl:flex-row xl:items-start xl:justify-between gap-[20px]">
          <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none xl:max-w-[497px]">
            {t("trade.security.title")}
          </h2>
          <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4] xl:max-w-[588px]">
            {t("trade.security.desc")}
          </p>
        </div>

        {/* Features grid */}
        <div className="flex flex-col xl:flex-row gap-[20px] xl:gap-[32px]">
          {/* Left column */}
          <div className="flex flex-col gap-[20px] xl:gap-[40px] xl:w-[600px]">
            <FeatureItem titleKey={FEATURES[0].titleKey} descKey={FEATURES[0].descKey} />
            <div className="h-[1px] bg-[#e5e5e5]" />
            <FeatureItem titleKey={FEATURES[1].titleKey} descKey={FEATURES[1].descKey} />
          </div>
          {/* Right column */}
          <div className="flex flex-col gap-[20px] xl:gap-[40px] xl:w-[600px]">
            <FeatureItem titleKey={FEATURES[2].titleKey} descKey={FEATURES[2].descKey} />
            <div className="h-[1px] bg-[#e5e5e5]" />
            <FeatureItem titleKey={FEATURES[3].titleKey} descKey={FEATURES[3].descKey} />
          </div>
        </div>

      </div>
    </section>
  );
}

export default Security;
